export const isTouchDevice = (): boolean => {
  if ("ontouchstart" in window) {
    return true;
  }
  return false;
};

export const isMobileSize = (): boolean => {
  return window.innerWidth < 480;
};
